import Swiper from 'swiper/bundle';

//下層スライダーの最小スライド数
const LOWER_MIN_SLIDES_PC = 4;
const LOWER_MIN_SLIDES_SP = 2;

export default class MySwiper {
  constructor(element) {
    this.element = element;
    this.swiper = null;
    this.parent = null;
    this.resizeTimer = null;
    this.isResizeBound = false;
    this.originalSlidesMarkup = '';
    if (this.element) {
      this.init();
    }
  }

  init() {
    if(this.element.classList.contains('js-swiper_base')) {
      this.baseSlide();
    }
    if (this.element.classList.contains('js-swiper_lower')) {
      this.lowerSlide();
    }
    if (this.element.classList.contains('js-swiper_pickup')) {
      this.pickupSlide();
    }
  }

  baseSlide() {
    this.parent = this.element.closest('.js-swiper_parent');
    if(!this.parent) {
      return;
    }
    const prev = this.parent.querySelector('.js-swiper-button-prev');
    const next = this.parent.querySelector('.js-swiper-button-next');
    const pagination = this.parent.querySelector('.js-swiper-pagination');

    const baseParam = {
      slidesPerView: 'auto',
      loop: true,
      speed: 1000,
      a11y: {
        slideRole: null,
      },
    };

    let swiperParam = { ...baseParam };

    if(prev && next) {
      swiperParam = {
        ...swiperParam,
        navigation: {
          prevEl: prev,
          nextEl: next,
        }
      };
    }

    if(pagination) {
      swiperParam = {
        ...swiperParam,
        pagination: {
          el: pagination,
          clickable: true,
        }
      };
    }

    this.swiper = new Swiper(this.element, swiperParam);
  }

  
  //再計算用に、複製したスライドの数をリセットする
  resetLoopSlides(wrapper) {
    if (!wrapper) {
      return;
    }

    if (!this.originalSlidesMarkup) {
      this.originalSlidesMarkup = wrapper.innerHTML;
      return;
    }

    wrapper.innerHTML = this.originalSlidesMarkup;
  }

  destroySwiper() {
    if (!this.swiper) {
      return;
    }

    this.swiper.destroy(true, true);
    this.swiper = null;
  }

  setLowerCarouselState(isEnabled) {
    this.parent.classList.toggle('is-lower-carousel-disabled', !isEnabled);
    this.element.classList.toggle('is-lower-carousel-static', !isEnabled);
  }

  prepareLoopSlides() {
    const wrapper = this.element.querySelector('.swiper-wrapper');
    let visibleCount = 1;

    //ループのためにスライドを複製
    if (wrapper) {
      this.resetLoopSlides(wrapper);

      const originalSlides = [...wrapper.children];
      if (originalSlides.length > 0) {
        //スライド1個分のwidthを取得
        const slideWidth = originalSlides[0].offsetWidth;
        //表示されているスライドの数を取得
        visibleCount = slideWidth
          ? Math.max(1, Math.ceil(this.element.offsetWidth / slideWidth))
          : 1;
        
        const loopBuffer = Math.max(1, Math.ceil(visibleCount / 2));
        // ループが安全に動くために必要なスライド数（バッファを含む）
        const minSlideCount = visibleCount + loopBuffer + 2;

        while (wrapper.children.length < minSlideCount) {
          originalSlides.forEach((slide) => {
            wrapper.appendChild(slide.cloneNode(true));
          });
        }
      }
    }

    return visibleCount;
  }

  getSwiperControls() {
    this.parent = this.element.closest('.js-swiper_parent');

    if (!this.parent) {
      return null;
    }

    return {
      prev: this.parent.querySelector('.js-swiper-button-prev'),
      next: this.parent.querySelector('.js-swiper-button-next'),
      pagination: this.parent.querySelector('.js-swiper-pagination'),
    };
  }

  //prev,next,ページネーションの処理を共通化
  applySwiperControls(swiperParam, controls) {
    let param = { ...swiperParam };

    if (controls.prev && controls.next) {
      param = {
        ...param,
        navigation: {
          prevEl: controls.prev,
          nextEl: controls.next,
        },
      };
    }

    if (controls.pagination) {
      param = {
        ...param,
        pagination: {
          el: controls.pagination,
          clickable: true,
        },
      };
    }

    return param;
  }

  pickupSlide() {
    const controls = this.getSwiperControls();

    if (!controls) {
      return;
    }

    const visibleCount = this.prepareLoopSlides();

    const swiperParam = this.applySwiperControls(
      {
        slidesPerView: 'auto',
        centeredSlides: true,
        loop: true,
        speed: 1000,
        watchOverflow: false,
        loopedSlides: visibleCount,
        loopAdditionalSlides: 0,
        breakpoints: {
          768: {
            centeredSlides: false,
          },
        },
        a11y: {
          slideRole: null,
        },
      },
      controls
    );

    this.swiper = new Swiper(this.element, swiperParam);
    // リサイズ時再計算
    this.bindResize(() => this.pickupSlide());
  }

  lowerSlide() {
    const controls = this.getSwiperControls();

    if (!controls) {
      return;
    }

    const wrapper = this.element.querySelector('.swiper-wrapper');
    let slideCount = 0;
    if (wrapper) {
      this.resetLoopSlides(wrapper);
      slideCount = wrapper.children.length;
    }

    this.destroySwiper();

    const isPc = window.matchMedia('(min-width: 768px)').matches;
    const minSlides = isPc ? LOWER_MIN_SLIDES_PC : LOWER_MIN_SLIDES_SP;

    //スライド数が閾値未満のとき、swiperの初期化を行わない
    if (slideCount < minSlides) {
      this.setLowerCarouselState(false);
      this.bindResize(() => this.lowerSlide());
      return;
    }

    this.setLowerCarouselState(true);

    const visibleCount = this.prepareLoopSlides();

    const swiperParam = this.applySwiperControls(
      {
        slidesPerView: 'auto',
        loop: true,
        speed: 1000,
        watchOverflow: false,
        loopedSlides: visibleCount,
        loopAdditionalSlides: 0,
        a11y: {
          slideRole: null,
        },
      },
      controls
    );

    this.swiper = new Swiper(this.element, swiperParam);
    //リサイズ時、再計算
    this.bindResize(() => this.lowerSlide());
  }

  bindResize(reinit) {
    if (this.isResizeBound) {
      return;
    }

    window.addEventListener('resize', () => {
      clearTimeout(this.resizeTimer);
      this.resizeTimer = window.setTimeout(() => {
        this.destroySwiper();
        reinit();
      }, 150);
    });

    this.isResizeBound = true;
  }
}
